import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { IRootState } from 'app/reducers/AppState';
import { AddHotspot } from 'app/views';
import {
  IRegion,
  IVehicleTypeListModel,
  IHotspotsModel,
  INewHotspotModel,
  IUserDetail
} from 'app/models';
import {
  fetchVehiclesTypesList,
  fetchHotspotDetails,
  saveHotspot,
  deleteHotspot,
  fetchDropTasks,
} from 'app/actions';

interface StateFromProps {
  selectedRegion: IRegion | null;
  vehicleTypesList: IVehicleTypeListModel[];
  hotspots: IHotspotsModel;
  userDetails: IUserDetail | null;
}

interface DispatchFromProps {
  fetchVehicleTypesList: () => void;
  fetchHotspotDetails: (id: string) => void;
  saveHotspot: (hotspot: INewHotspotModel, file: any) => void;
  deleteHotspot: () => void;
  fetchDropTasks: (id: string) => void;
}

const mapStateToProps = (state: IRootState): StateFromProps => ({
  selectedRegion: state.userDetails.selectedRegion,
  vehicleTypesList: state.vehicleTypes.vehicleTypesList,
  hotspots: state.hotspots,
  userDetails: state.userDetails.userDetails
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchFromProps => ({
  fetchVehicleTypesList: bindActionCreators(fetchVehiclesTypesList, dispatch),
  fetchHotspotDetails: bindActionCreators(fetchHotspotDetails, dispatch),
  saveHotspot: bindActionCreators(saveHotspot, dispatch),
  deleteHotspot: bindActionCreators(deleteHotspot, dispatch),
  fetchDropTasks: bindActionCreators(fetchDropTasks, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddHotspot);
